import { render, staticRenderFns } from "./vatSummaryBox.vue?vue&type=template&id=347f4bf6&"
import script from "./vatSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./vatSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports